import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59ac24d6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=59ac24d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ac24d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ac24d6')) {
      api.createRecord('59ac24d6', component.options)
    } else {
      api.reload('59ac24d6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=59ac24d6&scoped=true", function () {
      api.rerender('59ac24d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/frame/page/home/index.vue"
export default component.exports